import { render, staticRenderFns } from "./addLabel.vue?vue&type=template&id=3802133e&scoped=true&"
import script from "./addLabel.vue?vue&type=script&lang=js&"
export * from "./addLabel.vue?vue&type=script&lang=js&"
import style0 from "./addLabel.vue?vue&type=style&index=0&id=3802133e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3802133e",
  null
  
)

export default component.exports